import {UntypedFormControl} from '@angular/forms';

export function maxValueValidator(maxValue: number) {
  let thisControl: UntypedFormControl;

  return function maxValueValidate(control: UntypedFormControl) {
    // Initializing the validator.
    if (!thisControl) {
      thisControl = control;
    }

    if (thisControl.value > maxValue) {
      return {
        maxValue: true,
      };
    }

    return null;
  };
}

export function minValueValidator(minValue: any) {
  let thisControl: UntypedFormControl;

  return function minValueValidate(control: UntypedFormControl) {
    // Initializing the validator.
    if (!thisControl) {
      thisControl = control;
    }

    if (thisControl.value <= minValue) {
      return {
        minValue: true,
      };
    }

    return null;
  };
}
